(() => {
  if (window.PiurMobileScrollArrowsLoaded) return;
  window.PiurMobileScrollArrowsLoaded = true;

  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const controlsByScroller = new WeakMap();
  const caretIcon =
    '<svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  const getSlides = (scroller) =>
    Array.from(scroller.children).filter((child) => child.nodeType === Node.ELEMENT_NODE);

  const getStep = (scroller) => {
    const firstSlide = getSlides(scroller)[0];
    if (!firstSlide) return Math.max(240, Math.round(scroller.clientWidth * 0.85));

    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return Math.round(firstSlide.getBoundingClientRect().width + gap);
  };

  const getCurrentIndex = (scroller) => {
    const slides = getSlides(scroller);
    if (!slides.length) return 0;

    const scrollerRect = scroller.getBoundingClientRect();
    const center = scrollerRect.left + scrollerRect.width / 2;
    let nearestIndex = 0;
    let nearestDistance = Infinity;

    slides.forEach((slide, index) => {
      const rect = slide.getBoundingClientRect();
      const distance = Math.abs(rect.left + rect.width / 2 - center);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  };

  const updateControls = (scroller) => {
    const controls = controlsByScroller.get(scroller);
    if (!controls) return;

    const canScroll = mobileQuery.matches && scroller.scrollWidth > scroller.clientWidth + 4;
    controls.root.hidden = !canScroll;
    if (!canScroll) return;

    const maxScroll = scroller.scrollWidth - scroller.clientWidth;
    const atStart = scroller.scrollLeft <= 2;
    const atEnd = scroller.scrollLeft >= maxScroll - 2;
    const slides = getSlides(scroller);
    const current = getCurrentIndex(scroller);

    controls.prev.disabled = atStart;
    controls.next.disabled = atEnd;

    if (controls.current) controls.current.textContent = String(current + 1);
    if (controls.total) controls.total.textContent = String(Math.max(slides.length, 1));
  };

  const buildControls = (scroller) => {
    const showCounter = scroller.dataset.piurMobileScrollCounter === 'true';
    const root = document.createElement('div');
    root.className = 'piur-mobile-scroll-arrows';
    root.hidden = true;

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'piur-mobile-scroll-arrows__button piur-mobile-scroll-arrows__button--prev';
    prev.setAttribute('aria-label', 'Vorheriger Bereich');
    prev.innerHTML = caretIcon;

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'piur-mobile-scroll-arrows__button piur-mobile-scroll-arrows__button--next';
    next.setAttribute('aria-label', 'Nächster Bereich');
    next.innerHTML = caretIcon;

    let current = null;
    let total = null;

    root.append(prev);
    if (showCounter) {
      const counter = document.createElement('span');
      counter.className = 'piur-mobile-scroll-arrows__counter';
      current = document.createElement('span');
      total = document.createElement('span');
      counter.append(current, document.createTextNode('/'), total);
      root.append(counter);
    }
    root.append(next);

    prev.addEventListener('click', () => {
      scroller.scrollBy({ left: -getStep(scroller), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      scroller.scrollBy({ left: getStep(scroller), behavior: 'smooth' });
    });

    scroller.insertAdjacentElement('afterend', root);
    controlsByScroller.set(scroller, { root, prev, next, current, total });

    let scrollRaf = null;
    scroller.addEventListener('scroll', () => {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(() => {
        updateControls(scroller);
        scrollRaf = null;
      });
    }, { passive: true });

    const observer = new MutationObserver(() => updateControls(scroller));
    observer.observe(scroller, { childList: true });
  };

  const initScroller = (scroller) => {
    if (controlsByScroller.has(scroller)) {
      updateControls(scroller);
      return;
    }

    buildControls(scroller);
    updateControls(scroller);
  };

  const initAll = () => {
    document.querySelectorAll('[data-piur-mobile-scroll-arrows]').forEach(initScroller);
  };

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  mobileQuery.addEventListener?.('change', initAll);
  window.addEventListener('resize', initAll);
  window.setTimeout(initAll, 400);
})();
